import { TekenschemaPlot } from "../../../../content/wiskunde/functies/tekenschema/drawings/plots";
import * as React from 'react';
export default {
  TekenschemaPlot,
  React
};